"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScriptBreakdown = exports.FragmentBreakdown = void 0;
const UUID = __importStar(require("uuid"));
const is_uuid_1 = __importDefault(require("is-uuid"));
const object_hash_1 = __importDefault(require("object-hash"));
const slugBlocksToPrompterText_1 = require("./slugBlocksToPrompterText");
const types_1 = require("./types");
const slugTiming_1 = require("./slugTiming");
const timingStringParsers_1 = require("../timing/timingStringParsers");
const isValidBlockId = (rawId) => {
    if (typeof rawId === 'string') {
        return is_uuid_1.default.v4(rawId);
    }
    return false;
};
// ensure a predictable type for the element number for a block
// (since our schema is a little loosey goosey on attributes)
const extractElementNumber = (node) => {
    const rawValue = node.attrs.elementNumber;
    if (typeof rawValue === 'string' && rawValue.length > 0) {
        return rawValue;
    }
    return null;
};
// When we want a breakdown for a part of a script (e.g. when computing timing
// for a selection) we can create a FragmentBreakdown.
class FragmentBreakdown {
    constructor({ fragment, readRate, countExcludedTiming = false, }) {
        // Flattened array of all 2nd-level PM nodes (direct children of page)
        // with a couple of useful values extracted for typescript convenience
        this._blocks = [];
        this._readRate = readRate;
        this._countExcludedTiming = countExcludedTiming;
        fragment.forEach((page) => page.content.forEach((block) => {
            const elementType = block.type.name;
            const rawId = block.attrs.id;
            const id = isValidBlockId(rawId) ? rawId : null;
            const elementNumber = extractElementNumber(block);
            this._blocks.push({
                elementType,
                id,
                pmNode: block,
                elementNumber,
            });
        }));
    }
    // often we want to roll up by slug, this splits the blocks array by slug including the
    // zeroth slug
    get _slugChunks() {
        const chunks = [];
        let currentChunk = {
            isZeroth: true,
            contents: [],
        };
        this._blocks.forEach((block) => {
            if (block.elementType === 'slug') {
                chunks.push(currentChunk);
                currentChunk = {
                    isZeroth: false,
                    contents: [],
                    slug: block,
                };
            }
            else {
                currentChunk.contents.push(block);
            }
        });
        chunks.push(currentChunk);
        return chunks;
    }
    get prompterSlugs() {
        const result = [];
        this._slugChunks.forEach((chunk) => {
            const title = (0, types_1.isZerothChunk)(chunk) ? '' : chunk.slug.pmNode.textContent;
            const id = (0, types_1.isZerothChunk)(chunk) ? UUID.NIL : chunk.slug.id;
            const elementNumber = (0, types_1.isZerothChunk)(chunk)
                ? null
                : chunk.slug.elementNumber;
            const slugInfo = {
                elementType: 'slug',
                id,
                title,
                text: (0, slugBlocksToPrompterText_1.slugBlocksToPrompterText)(chunk.contents),
                isZerothSlug: chunk.isZeroth,
                elementNumber,
            };
            result.push({ ...slugInfo, hash: (0, object_hash_1.default)(slugInfo.text) });
        });
        return result;
    }
    get timing() {
        const slugs = [];
        this._slugChunks.forEach((chunk) => {
            const title = (0, types_1.isZerothChunk)(chunk) ? '' : chunk.slug.pmNode.textContent;
            const { bracketSeconds, dialogueSeconds } = (0, slugTiming_1.getSlugChunkTiming)({
                chunk,
                readRate: this._readRate,
                includeUntimed: this._countExcludedTiming,
            });
            slugs.push({
                isZerothSlug: (0, types_1.isZerothChunk)(chunk),
                title,
                bracketSeconds,
                dialogueSeconds,
                totalSeconds: dialogueSeconds + bracketSeconds,
            });
        });
        const result = {
            totalSeconds: 0,
            bracketSeconds: 0,
            dialogueSeconds: 0,
            slugs,
        };
        slugs.forEach((slugTiming) => {
            result.dialogueSeconds += slugTiming.dialogueSeconds;
            result.bracketSeconds += slugTiming.bracketSeconds;
            result.totalSeconds += slugTiming.totalSeconds;
        });
        return result;
    }
    getBlockSummaries(blockTypes) {
        const result = [];
        this._slugChunks.forEach((chunk) => {
            if (blockTypes.includes('slug')) {
                const slugId = (0, types_1.isZerothChunk)(chunk) ? UUID.NIL : chunk.slug.id || '';
                const text = (0, types_1.isZerothChunk)(chunk) ? '' : chunk.slug.pmNode.textContent;
                const elementNumber = (0, types_1.isZerothChunk)(chunk)
                    ? null
                    : extractElementNumber(chunk.slug.pmNode);
                const { totalSeconds } = (0, slugTiming_1.getSlugChunkTiming)({
                    chunk,
                    readRate: this._readRate,
                    includeUntimed: this._countExcludedTiming,
                });
                const summary = {
                    elementType: 'slug',
                    id: slugId,
                    text,
                    durationSeconds: totalSeconds,
                    elementNumber,
                };
                result.push(summary);
            }
            chunk.contents.forEach((block) => {
                if (!blockTypes.includes(block.elementType)) {
                    return;
                }
                const elementType = block.elementType;
                const id = block.id;
                const text = block.pmNode.textContent;
                const elementNumber = extractElementNumber(block.pmNode);
                if (elementType === 'bracket') {
                    result.push({
                        elementType: 'bracket',
                        id,
                        text,
                        timing: (0, timingStringParsers_1.getBracketTimingInfo)(block.pmNode),
                        elementNumber,
                    });
                }
                else {
                    result.push({
                        elementType,
                        id,
                        text,
                        elementNumber,
                    });
                }
            });
        });
        return result;
    }
}
exports.FragmentBreakdown = FragmentBreakdown;
// In the future, ScriptBreakdowns can allow properties beyond fragement breakdowns
class ScriptBreakdown extends FragmentBreakdown {
    constructor(doc, readRate) {
        super({
            fragment: doc.content,
            readRate,
        });
    }
}
exports.ScriptBreakdown = ScriptBreakdown;
